import React from 'react';
import {SortableElement} from "react-sortable-hoc";
import TaskItem from "./TaskItem";
import PropTypes from "prop-types";

const SortableItem = SortableElement(TaskItem);

class TasksList extends React.PureComponent {

    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    render() {
        let list = [];

        let editMode = this.props.editMode;
        if (this.props.completedList) {
            editMode = false;
        }

        let tasks = this.props.tasksList;
        for (let i = 0; i < tasks.length; i++) {
            let cur = tasks[i];
            if (this.props.completedList !== 'all') {
                if (this.props.completedList && cur.status === 0 || !this.props.completedList && cur.status !== 0) {
                    continue;
                }
            }

            list.push(editMode ? <SortableItem key={`item-${cur.id}`} index={i} value={cur} id={i} editMode={true} onEdit={this.props.onEdit} onSetFullDesk={this.props.onSetFullDesk} fullDescTask={cur.id === this.props.fullDescTask}/> :
                <div className='TaskCardWrapperND'
                     key={`item-${cur.id}`}><TaskItem id={i} value={cur} editMode={false} onSetFullDesk={this.props.onSetFullDesk} fullDescTask={cur.id === this.props.fullDescTask}/></div>);
        }
        return list;
    }
}

TasksList.propTypes = {
    tasksList: PropTypes.array.isRequired,
    fullDescTask: PropTypes.number,
    editMode: PropTypes.bool,
    completedList: PropTypes.any,
    onEdit: PropTypes.func,
    onSetFullDesk: PropTypes.func,
};
TasksList.defaultProps = {
    editMode: false,
}

export default TasksList;